import { render, staticRenderFns } from "./CommonAcfHero.vue?vue&type=template&id=34453af8&"
import script from "./CommonAcfHero.vue?vue&type=script&lang=ts&"
export * from "./CommonAcfHero.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports